import { Box, Divider, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Switch } from "@mui/material";
import FiberNewIcon from '@mui/icons-material/FiberNew';
import CameraFrontIcon from '@mui/icons-material/CameraFront';
import CameraIcon from '@mui/icons-material/Camera';
import RssFeedIcon from '@mui/icons-material/RssFeed';
import TimelineIcon from '@mui/icons-material/Timeline';
import { useEffect, useState } from "react";
import { getRandom, isEmpty } from "../../funcs";
import { Colors } from "../../styles/theme";
import YouTubeIcon from '@mui/icons-material/YouTube';
import LocalMoviesIcon from '@mui/icons-material/LocalMovies';
import LiveTvIcon from '@mui/icons-material/LiveTv';
import SeriesDialog from '../appDialog/series';
import BlogerDialog from '../appDialog/bloger';
import SearchDialog from "../appDialog";
import { DOMAIN } from '../../config';
import TelegramIcon from '@mui/icons-material/Telegram';
import MoviesDialog from "../appDialog/movies";
import AVDialog from "../appDialog/av";
import SaveIcon from '@mui/icons-material/Save';
import LatestDialog from "../appDialog/latest";
import TvDialog from "../appDialog/tv";


export default function SideBarList({open,setOpen,matches,setRealoding}){
  const [openSearch, setOpenSearch] = useState(false)
  const [chipTitle, setChipTitle] = useState(null)
  const [openSeries, setOpenSeries] = useState(false)
  const [openBloger, setOpenBloger] = useState(false)
  const [remark,setRemark] = useState(false)
  const [msgSnackOpen, setMsgSnackOpen] = useState(false)
  const [openFavor, setOpenFavor] = useState(false)
  const [telUser,setTelUser] = useState(null)
  const [appUrl, setAppUrl] = useState("")
  const [openAV, setOpenAV] = useState(false)
  const [openMovies, setOpenMovies] = useState(false)
  const [openLatest, setOpenLatest] = useState(false)
  const [openTv, setOpenTv] = useState(false)

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth' // 平滑滚动
    })
  }
  const handleClick = () => {
    scrollToTop()
    setTimeout(()=>{
      setMsgSnackOpen(true);
    },2000)
  };

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);

  }

  const handleOpenMovies= (text)=>{
    setChipTitle(text)
    setOpenMovies(true)
  }

  const handleOpenTv= (text)=>{
    setChipTitle(text)
    setOpenTv(true)
  }

  const handleOpenAv= (text)=>{
    setChipTitle(text)
    setOpenAV(true)
  }

 
  const handleOpenSearch = (text)=>{
    setChipTitle(text)
    setRemark(true)
    setOpenSearch(true)
  }

  const handleOpenSeries = (text)=>{
    setChipTitle(text)
    setOpenSeries(true)
  }
  const handleOpenFavor = (text)=>{
    setChipTitle(text)
    setRemark(true)
    setOpenFavor(true)
  }
  const handleOpenAPP = ()=>{
    window.open(appUrl, '_blank')
  }

  const handleClickLatest = (text)=>{
    
    setChipTitle(text)
    setOpenLatest(true)
  }
  useEffect(()=>{
    window.Telegram.WebApp.ready() 
    const tel_user = window.Telegram.WebApp.initDataUnsafe
        
    if(!isEmpty(tel_user)){
        setTelUser(tel_user)
    }
    fetch(`${DOMAIN}ywyminiappbot/get_app`)
    .then((response)=>response.json())
    .then((data)=>{
        setAppUrl(data[0].url)
        
    })
  },[])

    return(
        <Box position="fixed">
          <LatestDialog
            openSeries={openLatest} 
            setOpenSeries={setOpenLatest}
            matches={matches}
            chipTitle={chipTitle}
          />
            <SearchDialog 
                openSearch={openSearch} 
                setOpenSearch={setOpenSearch}
                matches={matches}
                chipTitle={chipTitle}
            />
            <SeriesDialog 
                openSeries={openSeries} 
                setOpenSeries={setOpenSeries}
                openSearch={openSearch} 
                setOpenSearch={setOpenSearch}
                matches={matches}
                chipTitle={chipTitle}
            />
            <BlogerDialog
                openBloger={openBloger}
                setOpenBloger={setOpenBloger}
                matches={matches}
            />
            <MoviesDialog
              openMovies={openMovies}
              setOpenMovies={setOpenMovies}
              matches={matches}
              chipTitle={chipTitle}
            />
            <TvDialog
              openMovies={openTv}
              setOpenMovies={setOpenTv}
              matches={matches}
              chipTitle={chipTitle}
            />
            <AVDialog
              openMovies={openAV}
              setOpenMovies={setOpenAV}
              matches={matches}
              chipTitle={chipTitle}
            />
            <List>
                  <ListItem key={getRandom+"最新发布"} disablePadding>
                  <ListItemButton onClick={e=>{handleClickLatest('最新发布')}}>
                    <ListItemIcon>
                      <FiberNewIcon sx={{color:Colors.primary}} /> 
                    </ListItemIcon>
                    <ListItemText  primary={"最新发布"} />
                  </ListItemButton>
                </ListItem>

                <ListItem key={getRandom+"淫妻自拍"} disablePadding>
                    <ListItemButton onClick={()=>{handleOpenSearch('淫妻绿帽')}}>
                    <ListItemIcon>
                        <CameraFrontIcon sx={{color:Colors.primary}} /> 
                    </ListItemIcon>
                    <ListItemText  primary={"淫妻自拍"} />
                    </ListItemButton>
                </ListItem>

                <ListItem key={getRandom+"系列专辑"} disablePadding>
                    <ListItemButton onClick={()=>{handleOpenSeries('专辑系列')}}>
                    <ListItemIcon>
                        <CameraIcon sx={{color:Colors.primary}} /> 
                    </ListItemIcon>
                    <ListItemText  primary={"系列专辑"} />
                    </ListItemButton>
                </ListItem>

                <ListItem key={getRandom+"热门博主"} disablePadding>
                    <ListItemButton onClick={()=>setOpenBloger(true)}>
                    <ListItemIcon>
                        <RssFeedIcon sx={{color:Colors.primary}} /> 
                    </ListItemIcon>
                    <ListItemText  primary={"热门博主"} />
                    </ListItemButton>
                </ListItem>
                <ListItem key={getRandom+"本周排行"} disablePadding>
                    <ListItemButton onClick={()=>{handleOpenSearch('周排行榜')}}>
                      <ListItemIcon>
                        <TimelineIcon sx={{color:Colors.primary}} /> 
                      </ListItemIcon>
                      <ListItemText  primary={"本周排行"} />
                    </ListItemButton>
                </ListItem>
            </List>
            <Divider color="#fff"/>
            <List>
            <ListItem key={getRandom+"免费AV"} disablePadding>
            <ListItemButton onClick={()=>{handleOpenAv('AV影院')}}>
              <ListItemIcon>
                <YouTubeIcon sx={{color:Colors.primary}} /> 
              </ListItemIcon>
              <ListItemText  primary={"免费AV"} />
            </ListItemButton>
          </ListItem>

          <ListItem key={getRandom+"免费电影"} disablePadding>
            <ListItemButton onClick={()=>{handleOpenMovies('电影')}}>
              <ListItemIcon>
                <LocalMoviesIcon sx={{color:Colors.primary}} /> 
              </ListItemIcon>
              <ListItemText  primary={"免费电影"} />
            </ListItemButton>
          </ListItem>

          <ListItem key={getRandom+"免费电视剧"} disablePadding>
            <ListItemButton onClick={()=>{handleOpenTv('电视剧')}}>
              <ListItemIcon>
                <LiveTvIcon sx={{color:Colors.primary}} /> 
              </ListItemIcon>
              <ListItemText  primary={"免费电视剧"} />
            </ListItemButton>
          </ListItem>

                
                
            </List>
            <Divider color="#fff"/>
      <List>
        
        <ListItem key={getRandom+"我的收藏"} disablePadding>
            <ListItemButton onClick={()=>{handleOpenFavor('我的收藏')}}>
              <ListItemIcon>
                <SaveIcon sx={{color:Colors.primary}} /> 
              </ListItemIcon>
              <ListItemText  primary={"我的收藏"} />
            </ListItemButton>
        </ListItem>
      </List>
      {telUser?
          <List>
            <ListItem disablePadding>
            <ListItemText 
                secondary={`${(telUser.user.first_name+" "+telUser.user.last_name).slice(0,12)} `}
                sx={{ 
                  textAlign:"center",
                  '& .MuiListItemText-primary': { fontSize: '20px' ,color:Colors.white}, 
                  '& .MuiListItemText-secondary': { fontSize: '16px',color:Colors.white } 
                }} 
              />
            </ListItem>
            <ListItem disablePadding>
              <ListItemText 
                secondary={`身份：VIP会员`}
                sx={{ 
                  textAlign:"center",

                  '& .MuiListItemText-primary': { fontSize: '20px' ,color:Colors.white}, 
                  '& .MuiListItemText-secondary': { fontSize: '12px',color:Colors.white } 
                }} 
              />
            </ListItem>
            <ListItem disablePadding>
              <ListItemText 
                secondary={`VIP到期时间：2025-2-1`}
                sx={{ 
                  textAlign:"center",
                  '& .MuiListItemText-primary': { fontSize: '20px' ,color:Colors.white}, 
                  '& .MuiListItemText-secondary': { fontSize: '12px',color:Colors.white } 
                }} 
              />
            </ListItem>
            <ListItem disablePadding>
              <ListItemText 
                secondary={`银币：293枚`}
                sx={{ 
                  textAlign:"center",

                  '& .MuiListItemText-primary': { fontSize: '20px' ,color:Colors.white}, 
                  '& .MuiListItemText-secondary': { fontSize: '12px',color:Colors.white } 
                }} 
              />
            </ListItem>
          </List>
          :
          <List>
            <ListItem disablePadding>
              <ListItemButton onClick={()=>{handleOpenAPP()}}>
                <ListItemIcon>
                  <TelegramIcon sx={{color:Colors.primary}} /> 
                </ListItemIcon>
                <ListItemText  primary={"电报小程序"} />
              </ListItemButton>
            </ListItem>
          </List>
        }
        </Box>
    )
}